module.exports = __webpack_public_path__ + "static/media/company.acd78184.svg";